<script setup>
import AiChatLoader from "@/components/aiChat/AiChatLoader.vue";
import useAiChat from "@/composables/useAiChat";
import {useRouter} from "vue2-helpers/vue-router";
import {ref} from "vue";

const router = useRouter();
const needId = ref(null);

const roundFormat = {
    answer: '',
};

const params = {
    url: '/chat-stream/get-match-response',
    roundFormat,
    addEvents: {
        'done': done
    }
}

const {
    question,
    loaderMessage,
    sendRequest,
} = useAiChat(params);

function done() {
    router.push('/needs/' + needId.value);
}

function start(id) {
    question.value = id;
    needId.value = id;
    sendRequest();
}

defineExpose({
    start
});
</script>

<template>
    <AiChatLoader :message="loaderMessage"/>
</template>

<style scoped>

</style>
